module.exports = __webpack_public_path__ + "assets-cabinet/img/logo.10ef6134.svg";